import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { getTableCells, methodResult, responseType } from '../../../utils/TableCells';
import { actions } from '../../modules/Actions';
import { addRowTotalAndColumnTotal, columnDisps, columnKeys, rowData, TableDataProps } from '../../../utils/NegotiationReducerUtils';
import { getReportTableRowKeys } from '../ReportTableRowReducer';
import _isEqual from 'lodash/isEqual';
import { contractAccuracyViewColumns } from '../../../Common';

export const probInitialState: TableDataProps = {
  // Stateの初期値
  header: columnKeys(contractAccuracyViewColumns),
  headerDisp: columnDisps(contractAccuracyViewColumns),
  data: rowData(),
};

function makingTableData(dtoToViewTable: methodResult, viewRow: string[]) {
  return {
    header: probInitialState.header,
    headerDisp: probInitialState.headerDisp,
    data: addRowTotalAndColumnTotal(dtoToViewTable, viewRow),
  };
}

export const NegotiationProbReducer = reducerWithInitialState(probInitialState).case(
  actions.updateNegotiation.prob,
  (state: TableDataProps, payload: responseType) => {
    const rowKeys = getReportTableRowKeys();
    const viewRowWithoutTotal = rowKeys.slice(1);
    const viewColumnsWithoutTotal = columnKeys(contractAccuracyViewColumns).slice(0, -1);
    const tableCells = getTableCells(payload, viewColumnsWithoutTotal, viewRowWithoutTotal);
    const newState = makingTableData(tableCells, viewRowWithoutTotal);

    return _isEqual(state.data, newState.data) ? state : newState;
  }
);
